// 🔴 LOCAL
// const API_BASE_URL = "http://localhost:5001";

// 🟢 AWS
const API_BASE_URL = "https://dizv6b75kj46r.cloudfront.net";


export { API_BASE_URL };